<template>
  <div>
    <div class="highPoweTwo-page" v-if="currentItem">
      <div class="bg"></div>
      <time-num></time-num>
      <div class="content">
        <div class="highPoweTwoTop">
          <div class="top">
            <img
              src="./../../assets/microscope/selectIcon.png"
              alt=""
            />当前倍镜
          </div>
          <div class="stem">
            <div>请分别观察40倍镜和100倍镜视野下的4张玻片</div>
            <div>并根据所有的图片中的信息答题</div>
          </div>
          <div class="bottom">
            <div class="left" @click="handleMultiplier(1)">
              <div class="multiplier">
                <img
                  src="./../../assets/microscope/multiplierIcon.png"
                  alt=""
                  srcset=""
                />
              </div>
              <div class="text">40x</div>
              <div class="solid" v-if="status === 1"></div>
            </div>
            <div class="right" @click="handleMultiplier(2)">
              <div class="multiplier">
                <img
                  src="./../../assets/microscope/multiplierIcon.png"
                  alt=""
                  srcset=""
                />
              </div>
              <div class="text">100x</div>
              <div class="solid" v-if="status === 2"></div>
            </div>
          </div>
        </div>
        <div class="smallBox">
          <div class="imgBox">
            <img
              @click="handleImg(currentItem.highImage1)"
              v-if="status === 1"
              :src="currentItem.highImage1"
              alt=""
              srcset=""
            />
            <img
              @click="handleImg(currentItem.highImage2)"
              v-if="status === 1"
              :src="currentItem.highImage2"
              alt=""
              srcset=""
            />
            <img
              @click="handleImg(currentItem.highImage3)"
              v-if="status === 2"
              :src="currentItem.highImage3"
              alt=""
              srcset=""
            />
            <img
              @click="handleImg(currentItem.highImage4)"
              v-if="status === 2"
              :src="currentItem.highImage4"
              alt=""
              srcset=""
            />
          </div>
        </div>
        <div class="choose-box">
          <div class="choose-text">
            {{ currentItem.highQuestions[2].title }} （
            {{ currentItem.highQuestions[2].typeName }} ）：
          </div>
          <div
            :class="item.type ? 'choose-active' : ''"
            class="choose-list"
            v-for="(item, index) in currentItem.highQuestions[2].optionList"
            @click="handleChooseClick(item, index)"
            :key="index"
          >
            <p>{{ item.value }}</p>
            <div class="choose-content">{{ item.content }}</div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div @click="handleBtn" class="btn">
          <img src="./../../assets/microscope/answerIcon.png" alt="" />
          提交并进入下一题
        </div>
      </div>
      <van-popup v-model="isShow" className="dialogImg">
        <div class="imgAmplify">
          <img :src="activeImg" alt="" />
        </div>
      </van-popup>
      <div class="mask" v-if="isErrorShow"></div>
      <div class="dialog" v-if="isErrorShow">
        <div class="title">提示！</div>
        <div class="text">
          <p>{{ tipText }}</p>
        </div>
        <div class="footer-modl" @click="handleOk">确定</div>
      </div>
    </div>
    <mi-xin></mi-xin>
  </div>
</template>

<script>
import MiXin from "../mixins/index";
import { mapState, mapMutations } from "vuex";
import TimeNum from "../mixins/timeNum";
export default {
  name: "Home2026",
  components: {
    MiXin,
    TimeNum,
  },
  data() {
    return {
      tipText: "请最少选择一个答案",
      isShow: false,
      isErrorShow: false,
      status: 1,
      chooseIndex: -1,
      currentItem: null,
      chooseItem: null,
      activeImg: null,
    };
  },
  computed: {
    ...mapState("microscope", ["num", "slideType", "slidePaper"]),
  },
  created() {},
  mounted() {
    this.currentItem = this.slidePaper[this.slideType];
    if (this.currentItem.highQuestions[2].type !== "1") {
      this.currentItem.highQuestions[2].optionList.map((item) => {
        item.type = false;
      });
    }
  },
  methods: {
    ...mapMutations("microscope", ["handleMicroscope"]),
    //关闭弹框
    handleOk() {
      this.isErrorShow = false;
    },

    // 切换40 100倍镜
    handleMultiplier(type) {
      this.status = type;
    },

    // 选中看大图
    handleImg(url) {
      this.activeImg = url;
      this.isShow = true;
    },

    // 提交
    handleBtn() {
      let answers = [];
      if (this.currentItem.highQuestions[2].type !== "1") {
        this.currentItem.highQuestions[2].optionList.map((item) => {
          if (item.type) {
            answers.push(item.value);
          }
        });
        if (answers.length < 2) {
          this.isErrorShow = true;
          this.tipText = "您尚未选择2个或以上答案";
          return false;
        }
      } else {
        this.currentItem.highQuestions[2].optionList.map((item) => {
          if (item.type) {
            answers.push(item.value);
          }
        });
        if (answers.length < 1) {
          this.isErrorShow = true;
          this.tipText = "请最少选择一个答案";
          return false;
        }
      }
      let item = {
        answers: answers.join(","),
        questionId: this.currentItem.highQuestions[2].id,
      };
      this.handleMicroscope({
        key: this.slideType === 0 ? "detail1" : "detail2",
        value: item,
      });
      this.$router.replace("/microscope/highPoweFour");
    },

    // 选题
    handleChooseClick(item, index) {
      if (
        this.currentItem.highQuestions[2].type === "2" ||
        this.currentItem.highQuestions[2].type === "3"
      ) {
        this.currentItem.highQuestions[2].optionList[index].type =
          !this.currentItem.highQuestions[2].optionList[index].type;
        this.$forceUpdate();
        return;
      }
      this.currentItem.highQuestions[2].optionList.forEach(
        (item) => (item.type = false)
      );
      this.currentItem.highQuestions[2].optionList[index].type = true;
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="less" scoped>
.highPoweTwo-page {
  width: 100%;
  min-height: 100vh;
  background-image: url("./../../assets/home/xwjBg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .bg {
    height: 10px;
  }
  .content {
    width: 653px;
    background: rgba(255, 255, 255, 0.15);
    box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
    border-radius: 60px;
    margin: 0 auto;
    padding-top: 1px;
    padding-bottom: 180px;
    margin-bottom: 130px;
    .highPoweTwoTop {
      width: 653px;
      height: 402px;
      background: rgba(255, 255, 255, 0.55);
      border: 2px solid #ffffff;
      border-radius: 60px;
      box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.38);
      margin: 0 auto;
      .top {
        margin-left: 48px;
        font-size: 35px;
        font-family: HarmonyOS Sans SC;
        font-weight: bold;
        color: #333333;
        margin-top: 28px;
        img {
          width: 30px;
          vertical-align: middle;
          margin-right: 24px;
        }
      }
      .stem {
        font-size: 25px;
        font-family: HarmonyOS Sans SC;
        font-weight: 400;
        color: #4c4c4c;
        margin-top: 30px;
        text-align: center;
      }
      .bottom {
        margin-left: 140px;
        margin-top: 35px;
        display: flex;
        .left {
          .multiplier {
            width: 134px;
            height: 134px;
            background: rgba(171, 59, 145, 0.2);
            border-radius: 50%;
            position: relative;
            img {
              position: absolute;
              top: 20px;
              left: 40px;
              display: block;
              width: 55px;
              margin: 0 auto;
            }
          }
          .text {
            font-size: 25px;
            font-family: HarmonyOS Sans SC;
            font-weight: 500;
            color: #333333;
            text-align: center;
            margin-top: 8px;
          }
          .solid {
            width: 134px;
            height: 5px;
            background: #ab3b91;
            border-radius: 2px;
            margin-top: 10px;
          }
        }
        .right {
          margin-left: 106px;
          .multiplier {
            width: 134px;
            height: 134px;
            background: rgba(171, 59, 145, 0.2);
            border-radius: 50%;
            position: relative;
            img {
              position: absolute;
              top: 20px;
              left: 40px;
              display: block;
              width: 55px;
              margin: 0 auto;
            }
          }
          .text {
            font-size: 25px;
            font-family: HarmonyOS Sans SC;
            font-weight: 500;
            color: #333333;
            text-align: center;
            margin-top: 8px;
          }
          .solid {
            width: 134px;
            height: 5px;
            background: #ab3b91;
            border-radius: 2px;
            margin-top: 10px;
          }
        }
      }
    }
    .smallBox {
      position: relative;
      .imgBox {
        width: 468px;
        margin: 0 auto;
        margin-top: 40px;
        display: flex;
        flex-wrap: wrap;
        img {
          width: 232px;
          height: 168px;
          margin-right: 2px;
        }
      }
      .tip {
        position: absolute;
        left: 60px;
        top: 25px;
        font-size: 22px;
        font-family: HarmonyOS Sans SC;
        font-weight: 400;
        color: #ab3b91;
      }
    }
    .choose-box {
      padding: 40px 45px 0 45px;
      .choose-text {
        font-size: 35px;
        font-family: HarmonyOS Sans SC;
        font-weight: bold;
        color: #333333;
        line-height: 50px;
      }
      .choose-list {
        background: #ffffff;
        box-shadow: 2px 3px 5px 0px rgba(14, 89, 145, 0.11);
        border-radius: 40px;
        margin-top: 20px;
        font-size: 25px;
        font-family: HarmonyOS Sans SC;
        font-weight: 400;
        color: #4d4d4d;
        display: flex;
        align-items: center;
        padding-left: 61px;
        p {
          position: relative;
          margin-right: 19px;
        }
        .choose-content {
          width: 5rem;
          padding: 10px 0px;
        }
        p::before {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: 39px;
          content: "";
          width: 2px;
          height: 38px;
          background: #cccccc;
        }
        div {
          margin-left: 35px;
        }
      }
      .choose-active {
        box-shadow: 2px 3px 5px 0px rgba(14, 89, 145, 0.11);
        background: #ab3b91;
        color: #fff;
      }
      .choose-active > p::before {
        background: #fff;
      }
    }
    .explain {
      font-size: 26px;
      font-family: HarmonyOS Sans SC;
      font-weight: 400;
      color: #4d4d4d;
      margin-top: 32px;
      text-align: center;
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    width: 570px;
    height: 143px;
    background: linear-gradient(0deg, #ffffff, #e9f4f2);
    box-shadow: 0px -5px 50px 0px rgba(84, 84, 84, 0.07);
    border-radius: 60px 60px 0px 0px;
    padding: 40px 90px 0 90px;
    display: flex;
    .btn {
      width: 514px;
      height: 88px;
      background: linear-gradient(
        132.74deg,
        rgba(0, 187, 177, 1) 0%,
        rgba(0, 86, 140, 1) 74.31%,
        rgba(171, 59, 127, 1) 100%
      );
      border: 1px solid #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
      line-height: 88px;
      border-radius: 44px;
      font-size: 35px;
      font-family: HarmonyOS Sans SC;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      margin: 0 auto;
      img {
        width: 35px;
        margin-right: 25px;
        vertical-align: middle;
      }
    }
  }
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: rgba(255, 255, 255, 0.8);
  }
  .dialog {
    width: 665px;
    height: 642px;
    position: fixed;
    z-index: 2;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background: #ffffff;
    box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
    border-radius: 60px;
    .title {
      height: 60px;
      font-size: 65px;
      font-family: HarmonyOS Sans SC;
      font-weight: bold;
      color: #ab3b91;
      text-align: center;
      margin-top: 100px;
    }
    .text {
      font-size: 35px;
      font-family: HarmonyOS Sans SC;
      font-weight: bold;
      color: #333333;
      line-height: 60px;
      text-align: center;
    }
    .mt100 {
      margin-top: 100px;
    }
    .flex {
      display: flex;
      padding: 120px 50px 0 50px;
      .btn {
        width: 260px;
        margin: 0 auto;
        height: 80px;
        line-height: 80px;
        text-align: center;
        font-size: 35px;
        font-family: HarmonyOS Sans SC;
        font-weight: 500;
        color: #ffffff;
        border-radius: 40px;
        background: linear-gradient(
          132.74deg,
          rgba(0, 187, 177, 1) 0%,
          rgba(0, 86, 140, 1) 74.31%,
          rgba(171, 59, 127, 1) 100%
        );
      }
    }
  }
}
::v-deep .van-popup {
  border-radius: 0;
  width: 98%;
  background: none;
  .imgAmplify {
    width: 92%;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: rgba(255, 255, 255, 0.8);
}
.dialog {
  width: 612px;
  height: 580px;
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background: #ffffff;
  box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
  border-radius: 60px;
  .title {
    font-size: 65px;
    font-family: HarmonyOS Sans SC;
    font-weight: bold;
    color: #ab3b91;
    text-align: center;
    margin-top: 100px;
  }
  .text {
    font-size: 35px;
    font-family: HarmonyOS Sans SC;
    font-weight: bold;
    color: #333333;
    line-height: 60px;
    margin-top: 80px;
    text-align: center;
  }
  .footer-modl {
    width: 262px;
    margin: 0 auto;
    height: 79px;
    background: linear-gradient(
      132.74deg,
      rgba(0, 187, 177, 1) 0%,
      rgba(0, 86, 140, 1) 74.31%,
      rgba(171, 59, 127, 1) 100%
    );
    border: 1px solid #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
    text-align: center;
    font-size: 35px;
    font-family: HarmonyOS Sans SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 79px;
    letter-spacing: 2px;
    border-radius: 40px;
    margin-top: 100px;
  }
}
</style>
